import { Component } from "@angular/core";
import { ControlContainer, FormGroupDirective } from "@angular/forms";
import { HeaderModel } from "src/app/_component/header/header.model";
import { HeaderService } from "src/app/_services/header.service";
import { SpaceService } from "src/app/_services/space.service";
import { SpaceType } from "src/app/_types/space-type";
@Component({
  selector: "app-parking-space-edit",
  templateUrl: "./parking-space-edit.page.html",
  styleUrls: ["./parking-space-edit.page.scss"],
  viewProviders: [
    { provide: ControlContainer, useExisting: FormGroupDirective },
  ],
})
export class ParkingSpaceEditPage {
  spaceType: SpaceType = SpaceType.Parking;
  headerInit: HeaderModel = {
    title: "",
    showRightButtonsOnlyOnMobile: true,
  };

  constructor(
    private spaceServ: SpaceService,
    private headerServ: HeaderService,
  ) {}

  ionViewDidLeave() {
    this.spaceServ.assignmentList = [];
    this.spaceServ.equipmentList = [];
  }

  // onHeaderInitChanged(event: HeaderModel) {
  //   this.headerInit = event;
  //   this.headerServ.setHeaderInit(this.headerInit);
  // }
}
